import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { Integrations } from 'SharedDir/declarations/integrations';
import { PaginationParams } from 'SharedDir/declarations/pagination';
import fileDownloader from 'SharedDir/utils/file-downloader';

export default class IntegrationHistoryApiClass extends SimpleApi<
  Integrations.PersonIntegrationsResultFull,
  never,
  never,
  Integrations.PersonIntegrationsResultBare,
  never,
  never,
  never
> {
  constructor() {
    super(`${SERVER_API}/integrations/persons/results`);
  }

  /**
   * @deprecated
   */
  async store(): Promise<never> {
    throw new Error('Method is not allowed.');
  }

  /**
   * @deprecated
   */
  async update(): Promise<never> {
    throw new Error('Method is not allowed.');
  }

  /**
   * @deprecated
   */
  async delete(): Promise<never> {
    throw new Error('Method is not allowed.');
  }

  async export<T extends object>(params: PaginationParams<T>) {
    params = { ...params, rowsPerPage: null, page: 1 };
    return http({
      method: 'GET',
      url: `${SERVER_API}/integrations/results/export`,
      params,
    });
  }
}
